import React, { useEffect, useState } from "react";
import { Row, Col, FormGroup, Label, Input, Button } from "reactstrap";
import usePlacesAutocomplete, { getGeocode, getLatLng } from "use-places-autocomplete";
import * as Yup from "yup";
import { ActiveBtn } from "../Utility/Button";
import LKCloseImg from "../../assets/images/LK_Icons/LK_Close.svg";
import LKSearchImg from "../../assets/images/LK_Icons/LK_Search.svg";
import { connect } from "react-redux";

const SearchLocation = (props) => {
  const { panToLocation, closeModal, locationData } = props;
  // usePlacesAutocomplete provides the suggesstion
  const { address, latitude, longitude } = locationData;
  const {
    ready,
    value,
    suggestions: { status, data },
    setValue,
    clearSuggestions,
  } = usePlacesAutocomplete({
    requestOptions: {
      location: { lat: () => 20.5937, lng: () => 78.9629 },
      radius: 20 * 1000,
    },
  });

  const [selectedAddress, setSelectedAddress] = useState(null);
  const [selectedLatlng, setSelectedLatlng] = useState({ lat: "", lng: "" });
  const [hoverIndex, setHoverIndex] = useState(null);
  const [isValidate, setIsValidate] = useState(false);

  useEffect(() => {
    setSelectedLatlng({
      lat: latitude,
      lng: longitude,
    });
    setSelectedAddress(address);
    setValue(address);
  }, []);
  const handleSelectAddress = async (address) => {
    try {
      const result = await getGeocode({ address });

      // Check if result is valid
      if (!result || result.length === 0) {
        console.error("No results found for the address.");
        return;
      }
      setSelectedAddress(result[0]);
      const latLngRes = await getLatLng(result[0]);

      const lat = latLngRes?.lat;
      const lng = latLngRes?.lng;
      setSelectedLatlng({ lat, lng });
      setSelectedAddress(result[0]?.formatted_address);
      panToLocation({
        lat,
        lng,
        selectedAddress: result[0]?.formatted_address,
      });
    } catch (err) {
      console.error("Error during geocode", err);
    }

    // Clean up input value and suggestions
    setValue(address, false);
    clearSuggestions();
  };
  // vaidate the create charger tab 1
  const createSearchValidation = Yup.object().shape({
    latitude: Yup.string()
      .nullable() // allows null or empty values
      .test("is-valid-latitude", "Latitude must be between -90 and 90", (value) => {
        if (value === "" || value === null || value === undefined) return true; // Allow empty or null values
        const lat = parseFloat(value);
        return !isNaN(lat) && lat >= -90 && lat <= 90;
      })
      .required(),

    longitude: Yup.string()
      .nullable() // allows null or empty values
      .test("is-valid-longitude", "Longitude must be between -180 and 180", (value) => {
        if (value === "" || value === null || value === undefined) return true; // Allow empty or null values
        const lon = parseFloat(value);
        return !isNaN(lon) && lon >= -180 && lon <= 180;
      })
      .required(),

    // address: Yup.string().required("Address is required."),
  });

  const validateSearch = async () => {
    try {
      const latitude = selectedLatlng?.lat;
      const longitude = selectedLatlng?.lng;
      await createSearchValidation.validate({ latitude, longitude });
      panToLocation({
        lat: latitude,
        lng: longitude,
        selectedAddress,
        isUpdate: true,
      });
      isValidate && setIsValidate(false);
      closeModal();
      // return true;
    } catch (err) {
      if (err.name === "ValidationError") {
        const msg = "Validation Error: " + err.errors.join(", ");
        // alert(msg);
        // console.log("Message validation: ", msg);
        setIsValidate(true);
        // return false;
      }
      setIsValidate(true);
    }
  };
  return (
    <div>
      <div style={styles.modalHeader}>
        <h5 style={styles.resetMargin}>Search for the Location</h5>
        <h1>
          {/* <i className="ri-close-line" style={styles.pointer} onClick={closeModal}></i> */}
          <img src={LKCloseImg} alt="closeImg" style={{ width: "20px", height: "20px", cursor: "pointer" }} onClick={closeModal} />
        </h1>
      </div>
      {isValidate && <span style={{ color: "red", fontSize: "16px" }}>Please select the address to proceed further....</span>}
      <Row style={{ display: "flex", alignItems: "center" }}>
        <Col lg={4}>
          <FormGroup>
            <Label htmlFor="address">Address</Label>

            <div className="input-group mb-2 mr-sm-2 position-relative">
              <div className="input-group-prepend">
                <div className="input-group-text">
                  {/* <i className="ri-search-line"></i> */}
                  <img src={LKSearchImg} alt="searchImg" style={{ width: "15px", height: "15px" }} onClick={closeModal} />
                </div>
              </div>
              <Input
                id="address"
                name="address"
                className="form-control"
                type="text"
                value={value}
                onChange={(e) => setValue(e.target.value)}
                disabled={!ready}
                placeholder="Search for Location"
              />
              <div
                className="input-group-postpend"
                onClick={() => {
                  setValue("", false);
                  setSelectedAddress("");
                  setSelectedLatlng({ lat: "", lng: "" });
                }}
              >
                <div className="input-group-text" style={styles.close}>
                  {/* <i className="ri-close-line"></i> */}
                  <img src={LKCloseImg} alt="closeImg" style={{ width: "15px", height: "15px" }} onClick={closeModal} />
                </div>
              </div>
            </div>
          </FormGroup>
        </Col>
        <Col lg={3}>
          <FormGroup>
            <Label htmlFor="latitude">Latitude</Label>
            <Input
              id="latitude"
              name="latitude"
              type="text"
              className="form-control"
              value={selectedLatlng?.lat}
              onChange={(e) => setSelectedLatlng({ ...selectedLatlng, lat: e.target.value })}
            />
          </FormGroup>
        </Col>
        <Col lg={3}>
          <FormGroup>
            <Label htmlFor="longitude">Longitude</Label>
            <Input
              id="longitude"
              name="longitude"
              type="text"
              className="form-control"
              value={selectedLatlng?.lng}
              onChange={(e) => setSelectedLatlng({ ...selectedLatlng, lng: e.target.value })}
            />
          </FormGroup>
        </Col>
        <Col lg={2} style={{ marginTop: props.layoutType === "vertical" ? "11px" : "5px", marginBottom: props.layoutType === "vertical" ? "" : "5px" }}>
          {/* <Button color="primary" type="submit" className="mr-2 waves-effect waves-light" onClick={validateSearch}>
            Done
          </Button> */}
          <ActiveBtn name={"Done"} handleClick={validateSearch} customWidth={"100px"} className="mr-2" />
        </Col>
      </Row>
      {status === "OK" && value && (
        <ul style={styles.dropdownContainer}>
          {data.map((suggestionData, index) => {
            const { id, description } = suggestionData;
            return (
              <li
                key={index}
                style={{
                  ...styles.list,
                  backgroundColor: hoverIndex === index && "#f9f9f9",
                }}
                onClick={() => handleSelectAddress(description)}
                onMouseOver={() => setHoverIndex(index)}
                onMouseLeave={() => setHoverIndex(null)}
              >
                {description}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};
const mapStateToProps = (state) => ({
  layoutType: state.Layout.layoutType,
});

export default connect(mapStateToProps)(SearchLocation);

const styles = {
  dropdownContainer: {
    listStyleType: "none",
    padding: 0,
    width: "600px",
    padding: "10px",
    borderRadius: "4px",
    marginTop: "10px",
    position: "absolute",
    top: "130px",
    left: "15px",
    maxHeight: "320px",
    height: "auto",
    backgroundColor: "#ffffff",
    zIndex: 10,
    border: "1px solid #ddd",
  },
  close: {
    borderLeft: "none",
    borderTopLeftRadius: "0",
    borderBottomLeftRadius: "0",
    cursor: "pointer",
    height: "39px",
  },
  list: {
    padding: "8px",
    borderBottom: "1px solid #ddd",
    cursor: "pointer",
  },
  resetMargin: { margin: "0" },
  openModalHeader: { color: "#005C8E", fontSize: 18, cursor: "pointer" },
  modalHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  pointer: { cursor: "Pointer" },
};
